<template>
    <div id="chizbi">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>&laquo;Чизби&raquo;: секрет вкусного завтрака</span></h1>
                <div class="text">&laquo;Чизби&raquo;&nbsp;&mdash; это настоящее творожное открытие! Сырники из&nbsp;свежайшего творога собственного производства 
                приготовлены в&nbsp;печи без капли растительного масла. Вкусные, натуральные, полезные. Хороши в&nbsp;компании густой сметаны, сгущенки или 
                ароматного варенья. Особенно на&nbsp;завтрак.</div>
                <div class="left">
                    <h3>Готовить не&nbsp;нужно &mdash; нужно только <span>разогреть!</span></h3>
                    <div class="block">Часто маленькие непоседы отказываются есть сырники. Предложите&nbsp;им творожники &laquo;Чизби&raquo;. Яркая упаковка, 
                    нежная консистенция, небольшой размер и&nbsp;необычная форма&nbsp;&mdash; дети останутся довольны!</div>
                </div>
                <div class="right">
                    <h3>Приготовлены в печи без капли растительного масла</h3>
                </div>
                <div class="block-text">Творожники &laquo;Чизби&raquo; такие легкие, что вот-вот взлетят в&nbsp;воздух, как настоящая тарелка фрисби! 
                Они&nbsp;&mdash; настоящее открытие для тех, кто любит что-то новенькое и&nbsp;особенное, но&nbsp;хочет жить полной жизнью, получая удовольствие 
                каждую минуту. &laquo;Чизби&raquo; готовы к&nbsp;употреблению: нужно только разогреть! Позвольте себе яркий и&nbsp;беззаботный отдых, ведь ЧИЗБИ 
                уже позаботились об&nbsp;уюте в&nbsp;вашем доме и&nbsp;вкусном завтраке... или ужине!</div>
            </div>
            <div class="list">
                <h2>Награды</h2>
                <div class="item-img1" onclick="location.href='https://cheesbee.com';">
                    <div class="item-content">
                        <h3>Творожники &laquo;Чизби&raquo;</h3>
                        <p>Победитель программы &laquo;Контрольная&nbsp;закупка&raquo;, 2018&nbsp;г.</p>
                        <p>Адрес веб-сайта:<br>
                        <a href="https://cheesbee.com">https://cheesbee.com</a>
                        </p>
                        <div class="image"></div>
                    </div>
                </div>
            </div>
       </section>
    </div>
</template>

<script>
    export default {
        name: "Chezbi"
    }
</script>